const all = ['userSessions']
const devices = [...all, 'devices']
const history = [...all, 'history']
const historyList = () => [...history]

export const userSessionsKeys = {
  all,
  devices,
  history,
  historyList,
}
